<div [class.version-none]="version === 'none'">
  <div class="main-container">
    <div
      class="editor-container editor-container_classic-editor editor-container_include-annotations"
      #editorContainerElement>
      <div class="editor-container__editor-wrapper">
        <div class="editor-container__editor">
          <div #editorElement>
            <ckeditor
              (change)="onEditorChange($event)"
              [disabled]="disabled"
              [editor]="Editor"
              [config]="config"
              (ready)="onReady($event)"
              *ngIf="Editor && config" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
